/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientSuggestionResponse } from './';
import {
    ClientSuggestionResponseFromJSON,
    ClientSuggestionResponseFromJSONTyped,
    ClientSuggestionResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientDetectionResponse
 */
export interface ClientDetectionResponse {
    /**
     * 
     * @type {ClientSuggestionResponse}
     * @memberof ClientDetectionResponse
     */
    clientFound?: ClientSuggestionResponse;
    /**
     * 
     * @type {Array<ClientSuggestionResponse>}
     * @memberof ClientDetectionResponse
     */
    suggestions: Array<ClientSuggestionResponse>;
}

/**
 * Check if a given object implements the ClientDetectionResponse interface.
 */
export function instanceOfClientDetectionResponse(value: object): value is ClientDetectionResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    return true;
}

export function ClientDetectionResponseFromJSON(json: any): ClientDetectionResponse {
    return ClientDetectionResponseFromJSONTyped(json, false);
}

export function ClientDetectionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientDetectionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientFound': json['clientFound'] == null ? undefined : ClientSuggestionResponseFromJSON(json['clientFound']),
        'suggestions': ((json['suggestions'] as Array<any>).map(ClientSuggestionResponseFromJSON)),
    };
}

export function ClientDetectionResponseToJSON(value?: ClientDetectionResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientFound': ClientSuggestionResponseToJSON(value['clientFound']),
        'suggestions': ((value['suggestions'] as Array<any>).map((v) => ClientSuggestionResponseToJSON(v))),
    };
}

